{
  "Approve": "Aprobar",
  "DeleteReminder": "Borrar recordatorio",
  "DismissAlert": "Descartar",
  "DismissReminder": "Descartar recordatorio",
  "EditReminder": "Editar recordatorio",
  "High": "Alto",
  "Reject": "Rechazar",
  "RemindMe15Min": "Recordatorio en 15 minutos",
  "RemindMe5Min": "Recordatorio en 5 minutos",
  "RemindMe60Min": "Recordatorio en una hora",
  "RemindMeTomorrow": "Recordatorio mañana",
  "Snooze": "Recordarme",
  "markAsRead": "Marcar como leído",
  "markAsUnread": "Marcar como no leído"
}
